import { z } from "zod";

export const logSchema = z.object({
  id: z.number(),
  subject_type: z.string(),
  subject_id: z.number(),
  event: z.string(),
  description: z.string(),
  properties: z.object({}),
  causer: z.object({
    id: z.number(),
    name: z.string(),
    label: z.string(),
    username: z.string(),
  }),
  created_at: z.string(),
  subject: z.object({
    log_label: z.string(),
  }),
});
